const mixpanel = require('mixpanel-browser');

mixpanel.init(
  process.env.VUE_APP_MIXPANEL_TOKEN,
  {
    api_host: 'https://api-eu.mixpanel.com',
    batch_requests: true,
  },
);

export default mixpanel;
